'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the trusted Marathi Shaadi App for Marathi Vadhu Var?', answer: 'For Marathi Vadhu Var MarathiVadhuVarSuchak.com is the most trusted mobile App.' },
  { question: 'How to do the Marathi Shaadi Login online?', answer: 'Visit MarathiVadhuVarSuchak.com Marathi matrimonial site for free registration. Then Marathi Vadhu Var can log in online for a free profile search.' },
  { question: 'How to check Marathi Shaadi Reviews online?', answer: 'You can check the MarathiVadhuVarSuchak.com Marathi matrimonial site review and then register for free.' },
  { question: 'How to create Marathi Shaadi Biodata online?', answer: 'To create Marathi Shaadi Biodata online, download the MarathiVadhuVarSuchak.com app for free registration.' },
  { question: 'How to understand Marathi Shaadi Rituals online?', answer: 'Follow MarathiVadhuVarSuchak.com blogs to understand Marathi Shaadi Rituals.' },
  { question: 'Which is the most trusted Marathi Shaadi website in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimonial is the most trusted Marathi Shaadi website in Maharashtra.' },
  { question: 'Which is the best Marathi matchmaking site in Pune?', answer: 'For Pune-based Marathi grooms and brides, MarathiVadhuVarSuchak.com Marathi matrimonial site, is the best option for free registration.' },
  { question: 'How to search Marathi Shaadi photos online?', answer: 'To search Marathi Vadhu Var profiles with a photo, you need to register for free on MarathiVadhuVarSuchak.com.' },
  { question: 'How to search Marathi Shaadi girl profiles online?', answer: "Marathi grooms can search Marathi brides' profiles after free registration through the MarathiVadhuVarSuchak.com site." },
  { question: 'How to search for the Marathi Shaadi girl photo with a full profile?', answer: "MarathiVadhuVarSuchak.com is the trusted brand for the Marathi brides' profiles with photos." },
  { question: 'Which is the trusted brand for Maratha Shaadi?', answer: 'MarathiVadhuVarSuchak.com is the trusted brand for Maratha Vadhu Var in Maharashtra state.' },
  { question: 'How to do the free registration for Marathi Anupam Shaadi?', answer: 'For Marathi marriage, MarathiVadhuVarSuchak.com allows free registration.' },
  { question: 'How to search free Marathi matrimonial profiles for Anupamshaadi?', answer: 'MarathiVadhuVarSuchak.com is the best option for free Marathi matrimonial profile registration.' },
  { question: 'How to do the Anupamshaadi login for Marathi Vadhu Var search?', answer: 'For Marathi Vadhu Var search, register free through MarathiVadhuVarSuchak.com Marathi matrimonial site.' },
  { question: 'How to do free registration for Marathi Shadi?', answer: 'Visit MarathiVadhuVarSuchak.com for free signup. After profile approval, you can search Marathi Vadhu Var profiles online.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Marathi Shaadi App" },
  { label: "Marathi Shaadi Login" },
  { label: "Marathi Shaadi Reviews" },
  { label: "Marathi Shaadi Biodata" },
  { label: "Marathi Shaadi Rituals" },
  { label: "Marathi Shaadi website" },
  { label: "Marathi matchmaking" },
  { label: "Marathi Shaadi photos" },
  { label: "Marathi Shaadi girl" },
  { label: "Marathi Shaadi girl photo" },
  { label: "Maratha Shaadi" },
  { label: "Anupam Shaadi" },
  { label: "Anupamshaadi" },
  { label: "Anupamshaadi Login" },
  { label: "Marathi Shadi" },
];

export default function MarathiShaadiAppClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_shaadi_app"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Shaadi App for Marathi Communities"
        items={communityServices}
      />

    </div>
  );
}
